<div class="app-integration-shipping-options-form">
  <div class="flex flex-wrap gap-4">
    <mat-checkbox
      *ngFor="let field of fieldsArray; trackBy: trackByLabel"
      class="lum-checkbox"
      [checked]="field.checked"
      (change)="onToggleField(field)"
      >{{ field.label }}</mat-checkbox
    >
  </div>

  <form [formGroup]="form" class="mt-4">
    <div class="flex flex-column gap-4 grow">
      <div
        *ngIf="shippingOptions.carrierCode.checked"
        class="flex align-center gap-3"
      >
        <div class="shipping-quote__label">Carrier</div>
        <div class="shipping-quote__input">
          <mat-select
            *ngIf="!loadingCarriers; else inputLoader"
            formControlName="carrierCode"
            class="lum-select"
            (selectionChange)="onSelectCarrier($event)"
          >
            <mat-option
              *ngFor="let carrier of carriers; trackBy: trackByCode"
              [value]="carrier?.code"
              >{{ carrier.name }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="carrierCodeControl && carrierCodeControl.invalid">{{
            carrierCodeControl | validateField
          }}</mat-error>
        </div>
      </div>

      <ng-container *ngIf="shippingOptions.weight.checked">
        <div class="flex align-center gap-3" formGroupName="weight">
          <div class="shipping-quote__label">Weight</div>
          <div class="shipping-quote__input flex gap-6">
            <div class="flex align-center gap-1">
              <div class="flex flex-column">
                <input
                  formControlName="valueLbs"
                  type="number"
                  min="0"
                  matInput
                  class="lum-input w-30"
                />
                <mat-error
                  *ngIf="weightValueControl && weightValueControl.invalid"
                  >{{ weightValueControl | validateField }}</mat-error
                >
              </div>
              <div class="flex">
                <span
                  class="
                    text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                  "
                >
                  (lbs)
                </span>
                <!-- <mat-menu class="lum-mat-menu" #menu="matMenu">
                  <button
                    *ngFor="let unit of weightUnits; trackBy: trackByLabel"
                    mat-menu-item
                    (click)="onSetUnit('weight.units', unit.value)"
                  >
                    {{ unit.value }} ({{ unit.label }})
                  </button>
                </mat-menu> -->
              </div>
            </div>

            <!-- OZ -->
            <div class="flex align-center gap-1">
              <div class="flex flex-column">
                <input
                  formControlName="valueOz"
                  type="number"
                  min="0"
                  matInput
                  class="lum-input w-30"
                />
                <mat-error
                  *ngIf="weightValueControl && weightValueControl.invalid"
                  >{{ weightValueControl | validateField }}</mat-error
                >
              </div>
              <div class="flex">
                <span
                  class="
                    text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                  "
                >
                  (oz)
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="shippingOptions.serviceCode.checked"
        class="flex align-center gap-3"
      >
        <div class="shipping-quote__label">Service</div>
        <div class="shipping-quote__input">
          <mat-select
            formControlName="serviceCode"
            class="lum-select"
            *ngIf="!loadingServices; else inputLoader"
            (selectionChange)="onServiceChange($event.value)"
          >
            <mat-option
              *ngFor="let service of services; trackBy: trackById"
              [value]="service?.code"
              >{{ service.name }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <div
        *ngIf="shippingOptions.packageCode.checked"
        class="flex align-center gap-3"
      >
        <div class="shipping-quote__label">Package</div>
        <div class="shipping-quote__input">
          <mat-select
            formControlName="packageCode"
            class="lum-select"
            *ngIf="!loadingPackages; else inputLoader"
          >
            <mat-option
              *ngFor="let package of packages; trackBy: trackById"
              [value]="package?.code"
              >{{ package?.name }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <ng-container *ngIf="shippingOptions.dimensions.checked">
        <div class="flex align-center gap-3" formGroupName="dimensions">
          <div class="shipping-quote__label">Size</div>
          <div class="shipping-quote__input flex justify-space-between gap-7">
            <div class="flex align-center gap-1">
              <input
                formControlName="length"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              L
            </div>
            <div class="flex align-center gap-1">
              <input
                formControlName="width"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              W
            </div>
            <div class="flex align-center gap-1">
              <input
                formControlName="height"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
              H
              <span
                class="text-underline cursor-pointer text-purple-600 font-semi-bold"
                #menuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="dimensionMenu"
              >
                ({{ dimensionUnit }})
              </span>
              <mat-menu class="lum-mat-menu" #dimensionMenu="matMenu">
                <button
                  *ngFor="let unit of dimensionUnits; trackBy: trackByLabel"
                  mat-menu-item
                  (click)="onSetUnit('dimensions.units', unit.value)"
                >
                  {{ unit.value }} ({{ unit.label }})
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="shippingOptions.confirmation.checked"
        class="flex align-center gap-3"
      >
        <div class="shipping-quote__label">Confirmation</div>
        <div class="shipping-quote__input flex align-center gap-2">
          <mat-select formControlName="confirmation" class="lum-select">
            <mat-option
              *ngFor="let option of confirmationOptions; trackBy: trackByValue"
              [value]="option"
              >{{ option }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <div
        *ngIf="
          ('utah_FR-577_bulk_update_requested_ship_date' | featureFlag) &&
          shippingOptions.shipByDate.checked
        "
      >
        <div class="shipping-quote__label">Requested Ship Date</div>
        <div class="shipping-quote__input flex align-center gap-2">
          <input
            formControlName="shipByDate"
            [matDatepicker]="picker"
            matInput
            placeholder="M/D/YYYY"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
    </div>

    <ng-container *ngIf="message">
      <div class="my-4 alert alert-warning">
        {{ message }}
      </div>
    </ng-container>

    <div class="flex gap-4 justify-end mt-4">
      <button
        *ngIf="!hideCancel"
        (click)="onCancel()"
        class="lum-button lum-button--tertiary"
      >
        Cancel
      </button>
      <button
        [disabled]="loading || !hasSameAppIntegrationId || !hasSelectedInputFields"
        (click)="onSubmit()"
        class="lum-button lum-button--primary"
      >
        {{ actionTitle }}
        <ng-container *ngIf="loading">
          <mat-spinner class="ml-2" [diameter]="16"></mat-spinner>
        </ng-container>
      </button>
    </div>
  </form>
</div>

<ng-template #inputLoader>
  <div class="lum-input">
    <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
  </div>
</ng-template>
